import { render, staticRenderFns } from "./LayerImportExtraAttributes.vue?vue&type=template&id=7549a570&scoped=true"
import script from "./LayerImportExtraAttributes.vue?vue&type=script&lang=js"
export * from "./LayerImportExtraAttributes.vue?vue&type=script&lang=js"
import style0 from "./LayerImportExtraAttributes.vue?vue&type=style&index=0&id=7549a570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7549a570",
  null
  
)

export default component.exports